import $ from 'jquery';

export function registerCustomTooltipPlugin() {
	$.extend($.fn, {
		ctxsAddCustomTooltip($toolTip: JQuery, $container: JQuery) {
			const self = this;

			function show(pageX: number, pageY: number) {
				hideAll();
				if ($(window).height() - pageY > 200) {
					$toolTip.css({ left: pageX, top: pageY }).show();
				} else {
					$toolTip
						.css({ left: pageX, top: self.offset().top - $toolTip.height() - 40 })
						.show();
				}
			}

			function hideAll() {
				$container.find('.pluginassistant-popup').hide();
			}

			this.on('mouseleave focusout', function () {
				$toolTip.hide();
			});

			this.on('mouseenter', (event: JQueryEventObject) => {
				//show relative to mouse pointer + 20px to show below mouse cursor
				show(event.pageX, $(this).offset().top + $(this).outerHeight(true) + 20);
			});

			this.on('click', (event: JQueryEventObject) => {
				event.preventDefault();
				if ($toolTip.is(':visible')) {
					$toolTip.hide();
				} else {
					show(self.offset().left, $(this).offset().top + $(this).outerHeight(true));
				}
			});

			$toolTip.hide();
		},
	});
}
